import React from 'react'

function LogRegLayout({ children}) {
    return (
        <div className="h-screen md:bg-scogof2 overflow-x-hidden">
            {children}
        </div>
    )
}

export default LogRegLayout;
